import { render, staticRenderFns } from "./AddCoach.vue?vue&type=template&id=b088383c"
import script from "./AddCoach.vue?vue&type=script&lang=ts"
export * from "./AddCoach.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports